import React from 'react'
import { Route, Switch, Redirect } from 'react-router-dom'
import { ConnectedRouter } from 'connected-react-router'
import Loadable from 'react-loadable'

import Loader from 'components/LayoutComponents/Loader'
import IndexLayout from 'layouts'
import NotFoundPage from 'pages/404'

const loadable = loader =>
  Loadable({
    loader,
    delay: false,
    loading: () => <Loader />,
  })

const routes = [
  // System Pages
  {
    path: '/user/logoutresponse',
    component: loadable(() => import('pages/user/logoutResponse')),
    exact: true,
  },
  {
    path: '/user/loginresponse',
    component: loadable(() => import('pages/user/LoginResponse')),
    exact: true,
  },
  {
    path: '/user/login',
    component: loadable(() => import('pages/user/login')),
    exact: true,
  },
  {
    path: '/user/forgot',
    component: loadable(() => import('pages/user/forgot')),
    exact: true,
  },
  {
    path: '/userlist',
    component: loadable(() => import('pages/user/userlist')),
  },

  // Dashboards
  {
    path: '/dashboard/alpha',
    component: loadable(() => import('pages/dashboard/alpha')),
  },

  // TLS modules
  {
    path: '/client',
    component: loadable(() => import('pages/client')),
  },
  {
    path: '/supplier',
    component: loadable(() => import('pages/supplier')),
  },
  // {
  //   path: '/Metal',
  //   component: loadable(() => import('pages/inward')),
  // },
  {
    path: '/inwardDetail',
    component: loadable(() => import('pages/inwardDetail')),
  },
  {
    path: '/comingsoon',
    component: loadable(() => import('pages/comingsoon')),
    exact: true,
  },
  {
    path: '/usermanagement',
    component: loadable(() => import('pages/usermanagement')),
    exact: true,
  },
  // {
  //   path: '/Minerals',
  //   component: loadable(() => import('pages/inward')),
  // },
  {
    path: '/inward/:type',
    component: loadable(() => import('pages/inward')),
  },
  {
    path: '/apiCredentials',
    component: loadable(() => import('pages/apiCredentials')),
  },
  {
    path: '/factory/factory-dashboard',
    component: loadable(() => import('pages/factory/factory-dashboard')),
  },
  {
    path: '/factory/jewellery-articles',
    component: loadable(() => import('pages/factory/jewellery-articles')),
  },
  {
    path: '/factory/jewelleryarticles/documents',
    component: loadable(() => import('pages/factory/jewellery-articles/documents')),
  },
  {
    path: '/auditors/auditors-dashboard',
    component: loadable(() => import('pages/auditors/auditors-dashboard')),
  },
  {
    path: '/auditors/jewellery-articles',
    component: loadable(() => import('pages/auditors/jewellery-articles')),
  },
  {
    path: '/brand/brand-dashboard',
    component: loadable(() => import('pages/brand/brand-dashboard')),
  },
  {
    path: '/profile',
    component: loadable(() => import('pages/profile')),
    exact: true,
  },
  {
    path: '/factory/jewelleryarticles/article_audit_details',
    component: loadable(() => import('pages/factory/jewellery-articles/article_audit_details')),
  },
  {
    path: '/enduser/jewellery/:articleid/:guid?',
    component: loadable(() => import('pages/end_user_page')),
    name: '/Jewellery',
    params: 'loginnotrequired',
  },
  {
    path: '/enduser/tousConsumerPage',
    component: loadable(() => import('pages/end_user_page/tousConsumerPage')),
  },
  {
    path: '/enduser/diamonds',
    component: loadable(() => import('pages/end_user_page/diamond')),
  },
  {
    path: '/enduser/notfound',
    component: loadable(() => import('pages/end_user_page/data_not_found')),
  },
  {
    path: '/import/:type',
    component: loadable(() => import('pages/import')),
  },
  {
    path: '/bulkupload/:type',
    component: loadable(() => import('pages/bulkupload')),
  },
  {
    path: '/factory/jewelleryarticles/consumerPersonalizeInfo/:Id',
    component: loadable(() => import('pages/factory/jewellery-articles/consumerPersonalizeInfo')),
  },
  {
    path: '/auditor/mappingnotfound',
    component: loadable(() => import('pages/auditors/factorymappingnotfound')),
  },
  {
    path: '/rmcode',
    component: loadable(() => import('pages/RMCodeConfiguration')),
  },
  {
    path: '/enduser/consumerByUniquecode',
    component: loadable(() => import('pages/end_user_page/consumerByUniquecode')),
  },
  {
    path: '/(Factory|Wholesaler)',
    component: loadable(() => import('pages/factory')),
  },
  {
    path: '/transfer',
    component: loadable(() => import('pages/transferTransactionConfiguration')),
  },
  {
    path: '/transferdetail/:Id/:index?',
    component: loadable(() => import('pages/TransferTransactionDetail')),
  },
  {
    path: '/transferrequest',
    component: loadable(() => import('pages/ReceivedTransfer')),
  },
  {
    path: '/transferrequestdetail/:Id',
    component: loadable(() => import('pages/ReceivedTransfer/ReceivedTransferDetail')),
  },
  {
    path: '/qrcode',
    component: loadable(() => import('pages/QRCodeManagement')),
  },
  {
    path: '/CertifiedStone/TransferRequest',
    component: loadable(() => import('pages/CertifiedStone/TransferRequest')),
  },
  {
    path: '/certifiedstonetransferrequestdetails/:Id',
    component: loadable(() =>
      import('pages/CertifiedStone/TransferRequest/TransferRequestDetails'),
    ),
  },
  {
    path: '/CertifiedStone/Transfer',
    component: loadable(() => import('pages/CertifiedStone/TransferDetail')),
  },
  {
    path: '/CertifiedStoneTransfer/:Id/:index?',
    component: loadable(() => import('pages/CertifiedStone/TransferDetail/TransferDetailDetails')),
  },
  {
    path: '/CertifiedStone/CertifiedStoneDetail/:Id',
    component: loadable(() => import('pages/CertifiedStone/CertifiedStoneDetail')),
  },
  {
    path: '/CertifiedStone',
    component: loadable(() => import('pages/CertifiedStone')),
  },
  {
    path: '/enduser/certifiedstone/:certreportno',
    component: loadable(() => import('pages/end_user_page/CertifiedStoneTraceability')),
    name: '/CertifiedStoneTracebility',
    params: 'loginnotrequired',
  },
  {
    path: '/enduser/certifiedstonelist/:uniquecode',
    component: loadable(() => import('pages/end_user_page/CertifiedStoneByUniqueCode/')),
  },
  // company Profile
  {
    path: '/companyprofile',
    component: loadable(() => import('pages/companyProfile')),
  },

  // Document Media Types
  {
    path: '/documenttypelist',
    component: loadable(() => import('pages/documenttype')),
  },
  // originmasterlist
  {
    path: '/originmasterlist',
    component: loadable(() => import('pages/originmaster')),
  },
  // Specilization Master
  {
    path: '/specilizationlist',
    component: loadable(() => import('pages/specilization')),
  },
  // Attribute Master
  {
    path: '/attributelist',
    component: loadable(() => import('pages/attribute')),
  },

  // Error Log
  {
    path: '/errorlog',
    component: loadable(() => import('pages/errorlog')),
  },

  // UI Error Log
  {
    path: '/uierrorlog',
    component: loadable(() => import('pages/uierrorlog')),
  },

  // Country of Origin
  {
    path: '/origincountrylist',
    component: loadable(() => import('pages/origincountrymaster')),
  },

  // Role Rights
  {
    path: '/rolerights',
    component: loadable(() => import('pages/RoleRights')),
  },
  // State
  {
    path: '/statelist',
    component: loadable(() => import('pages/state')),
  },
  {
    path: '/factoryuploadlist',
    component: loadable(() => import('pages/factoryUpload')),
  },
  // Country
  {
    path: '/countrylist',
    component: loadable(() => import('pages/country')),
  },
  // Client Contact Information
  {
    path: '/clientcontactlist',
    component: loadable(() => import('pages/client/clientcontactinfo')),
    exact: true,
  },
  //
  {
    path: '/jewelleryarticleinfo',
    component: loadable(() => import('pages/factory/jewellery-articles/jewelleryArticleInfo')),
  },

  // {
  //   path: '/design',
  //   component: loadable(() => import('pages/PageBuilder/pagebuilder.js')),
  // },

  {
    path: '/enduser/preview/:id?',
    component: loadable(() => import('pages/dynamicPanels/preview')),
  },

  {
    path: '/panels',
    component: loadable(() => import('pages/dynamicPanels')),
  },

  {
    path: '/design/:id?',
    component: loadable(() => import('pages/dynamicPanels/addDynamicPanel')),
  },
  {
    path: '/panelDetail',
    component: loadable(() => import('pages/dynamicPanels/panelDetail.js')),
  },
  {
    path: '/panelConfiguration',
    component: loadable(() => import('pages/dynamicPanels/panelConfiguration')),
  },
  {
    path: '/languages',
    component: loadable(() => import('pages/languageMaster')),
  },
]

class Router extends React.Component {
  render() {
    const { history } = this.props
    return (
      <ConnectedRouter history={history}>
        <IndexLayout>
          <Switch>
            <Route exact path="/" render={() => <Redirect to="/dashboard/alpha" />} />
            {routes.map(route => (
              <Route
                path={route.path}
                component={route.component}
                key={route.path}
                // exact={route.exact}
              />
            ))}
            <Route component={NotFoundPage} />
          </Switch>
        </IndexLayout>
      </ConnectedRouter>
    )
  }
}

export default Router
